//
// The only auth copy that is allowed in the entry bundle: the header's account button and the toast
// shown when a session ends. Keep this file tiny — everything else lives in lazy chunks.

export interface SessionCopy {
  /** The signed-in account button's accessible name. */
  trigger: string;
  endedTitle: string;
  endedDescription: string;
}

export const sessionContent = {
  trigger: 'Account menu, signed in as {name}',
  endedTitle: 'You were signed out',
  endedDescription: 'Please sign in again.',
} satisfies SessionCopy;
